// extracted by mini-css-extract-plugin
export default {"dialogContent":"MaterialsInput_dialogContent__X14In"};